<button type="button"
        class="photo-capture-button"
        [disabled]="disabled()"
        [attr.aria-disabled]="disabled()"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-controls]="inputId() + '-input'"
        (click)="trigger()"
        [attr.data-testid]="testId()">
  <span class="photo-capture-icon">
    <i class="pi pi-camera"
       aria-hidden="true"></i>
    @if (count() > 0) {
      <p-badge [value]="count().toString()"
               severity="danger"
               badgeSize="small"
               styleClass="bqa-icon-badge"
               [attr.data-testid]="testId() + '-count'" />
    }
  </span>
</button>

<input #fileInput
       type="file"
       accept="image/*"
       [attr.capture]="source() === 'camera' ? 'environment' : null"
       [attr.multiple]="source() === 'library' ? '' : null"
       [attr.id]="inputId() + '-input'"
       style="display: none"
       (change)="handleFiles($event)"
       [attr.data-testid]="testId() + '-input'" />
